import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'addNewScenarioFilter'
})
export class AddNewScenarioFilterPipe implements PipeTransform {
  transform(items: any[]): any[] {
    if (!items) return [];
    return items.filter(it => it.name != "" && it.name != null);
  }
}